import React from 'react';
import type { PropsWithChildren } from 'react';
import { Grid, useTheme } from '@mui/material';

import useCaptureMarketingData from '@/hooks/useCaptureMarketingData';
import useComposePageBySlug from '@/hooks/useComposePageBySlug';
import Footer from './Footer';
import Header from './Header';
import PasswordGate from './PasswordGate/PasswordGate';

export type LayoutProps = PropsWithChildren<{}>;

const Layout = ({
  children,
}: LayoutProps) => {
  const { palette } = useTheme();

  const path = typeof children?.props?.path === 'string'
    ? children.props.path.replace(/^\/|\/$/g, '')
    : '';

  const composePage = useComposePageBySlug(path);
  const requiresPassword = composePage?.requiresPassword ?? false;

  useCaptureMarketingData();

  return (
    <PasswordGate isProtected={requiresPassword}>
      <Grid
        container
        direction="column"
        maxWidth="100vw"
      >
        <Grid item>
          <Header />
        </Grid>

        <Grid item component="main" className="main" sx={{ overflowX: 'clip' }}>
          {children}
        </Grid>

        <Grid
          item
          sx={{ backgroundColor: palette.color?.impgray700 }}
        >
          <Footer />
        </Grid>
      </Grid>
    </PasswordGate>
  );
};

export default Layout;
